




















































import { Vue, Component, Prop } from "vue-property-decorator";
import Tuple from "@/models/Tuple";
import VIcon from "@/components/VIcon.vue";

@Component({
  components: {
    VIcon,
  },
})
export default class VMultiTuple extends Vue {
  @Prop({ required: true }) readonly value!: Tuple[];
  @Prop({ default: true }) readonly multiple!: boolean[];
  private insertedTuples: Tuple[] = [];

  created() {
    if (this.value && this.value.length > 0) {
      this.insertedTuples = [...this.value];
    } else {
      this.addTuple();
    }
  }

  get tuples() {
    return this.insertedTuples;
  }

  private isLastTuple(index: number) {
    return this.insertedTuples.length - 1 === index;
  }

  private emitValues() {
    this.$emit("input", this.insertedTuples);
  }

  private deleteTuple(index: number) {
    this.insertedTuples.splice(index, 1);
    this.$emit("input", this.insertedTuples);
  }

  private addTuple() {
    this.insertedTuples.push({ x: null, y: null, z: null });
  }
}
